import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getApplicationToFastestPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/prihlaska-do-fastest",
		[Locale.en]: "/application-to-fastest",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
